// Helper para o filtro de período do painel Analytics de Conversão.

export type AnalyticsPeriod = "today" | "24h" | "7d" | "30d";

export function periodToSince(period: AnalyticsPeriod): Date {
  const now = new Date();
  switch (period) {
    case "today": {
      const d = new Date(now);
      d.setHours(0, 0, 0, 0);
      return d;
    }
    case "24h":
      return new Date(now.getTime() - 24 * 60 * 60 * 1000);
    case "7d":
      return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    case "30d":
      return new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  }
}

export function periodLabel(period: AnalyticsPeriod): string {
  switch (period) {
    case "today":
      return "Hoje";
    case "24h":
      return "Últimas 24h";
    case "7d":
      return "Últimos 7 dias";
    case "30d":
      return "Últimos 30 dias";
  }
}

export function periodBucketCount(period: AnalyticsPeriod): number {
  // número de buckets diários para o gráfico
  switch (period) {
    case "today":
      return 1;
    case "24h":
      return 1;
    case "7d":
      return 7;
    case "30d":
      return 30;
  }
}
